// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IPlanIdsDto
 */
export interface IPlanIdsDto {
    /**
     * 
     * @type {Array<number>}
     * @memberof IPlanIdsDto
     */
    plan_to_org_level_plan_ids: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof IPlanIdsDto
     */
    org_to_plan_level_plan_ids: Array<number>;
}

/**
 * Check if a given object implements the IPlanIdsDto interface.
 */
export function instanceOfIPlanIdsDto(value: object): value is IPlanIdsDto {
    if (!('plan_to_org_level_plan_ids' in value) || value['plan_to_org_level_plan_ids'] === undefined) return false;
    if (!('org_to_plan_level_plan_ids' in value) || value['org_to_plan_level_plan_ids'] === undefined) return false;
    return true;
}

export function IPlanIdsDtoFromJSON(json: any): IPlanIdsDto {
    return IPlanIdsDtoFromJSONTyped(json, false);
}

export function IPlanIdsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPlanIdsDto {
    if (json == null) {
        return json;
    }
    return {
        
        'plan_to_org_level_plan_ids': json['plan_to_org_level_plan_ids'],
        'org_to_plan_level_plan_ids': json['org_to_plan_level_plan_ids'],
    };
}

export function IPlanIdsDtoToJSON(json: any): IPlanIdsDto {
    return IPlanIdsDtoToJSONTyped(json, false);
}

export function IPlanIdsDtoToJSONTyped(value?: IPlanIdsDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'plan_to_org_level_plan_ids': value['plan_to_org_level_plan_ids'],
        'org_to_plan_level_plan_ids': value['org_to_plan_level_plan_ids'],
    };
}

